// extracted by mini-css-extract-plugin
export default {"wrapper":"Slideshow_wrapper__W5rBe","logoBlock":"Slideshow_logoBlock__hMd10","logo":"Slideshow_logo__3p9cp","photoBlock":"Slideshow_photoBlock__QqgYA"};